const STORAGE_KEY = 'motolog.screenshotPlatform';
const isPlatform = value => value === 'android' || value === 'ios';

// One preference for every screenshot component, page and language on this origin.
// Browsing remains functional when storage is disabled or unavailable.
function createScreenshotPreference(host) {
    let storage;
    let current = null;
    try {
        storage = host.localStorage;
        const saved = storage.getItem(STORAGE_KEY);
        if (isPlatform(saved)) current = saved;
    } catch (_) { /* Keep an in-memory preference for this page. */ }
    const listeners = new Set();
    const update = value => {
        current = value;
        listeners.forEach(listener => listener(current));
    };
    const onStorage = event => {
        if (event.storageArea && event.storageArea !== storage) return;
        if (event.key !== STORAGE_KEY && event.key !== null) return;
        update(isPlatform(event.newValue) ? event.newValue : null);
    };
    host.addEventListener('storage', onStorage);
    return {
        get: () => current,
        select(platform) {
            if (!isPlatform(platform)) return;
            try { storage?.setItem(STORAGE_KEY, platform); } catch (_) { /* In-memory selection still works. */ }
            update(platform);
        },
        subscribe(listener) {
            listeners.add(listener);
            listener(current);
            return () => listeners.delete(listener);
        },
        destroy() {
            host.removeEventListener('storage', onStorage);
            listeners.clear();
        },
    };
}

module.exports = {createScreenshotPreference, STORAGE_KEY};
